import Heading from '../Heading/Heading'
import classNames from 'classnames'
import * as styles from './FeatureStrip.module.scss'
import LinkWithArrow from '../LinkWithArrow/LinkWithArrow'
import Text from '../../components/Text/Text'

const FeatureStrip = ({
  ctaUrl,
  ctaText,
  externalUrl,
  title,
  featureItems,
  text
}) => {
  return (
    <section className={styles.featureStripContainer}>
      <Heading className={styles.featureStripTitle}>{title}</Heading>
      <Text fontSize="large" className={styles.featureStripBody}>
        {text}
      </Text>
      <ul className={styles.featureStripLogoRow}>
        {featureItems.map((feature, index) => (
          <li key={index} className={styles.featureStripLogoCircleContainer}>
            <picture
              className={classNames(
                styles.featureStripLogoCircle,
                feature.className
              )}
              style={feature.style}>
              <img
                src={feature.imgSrc}
                alt={feature.imgAlt}
                className={styles.featureStripLogo}
                loading="lazy"
              />
            </picture>
            {feature.title && (
              <span className={styles.featureStripImageTitle}>
                {feature.title}
              </span>
            )}
          </li>
        ))}
      </ul>
      {ctaUrl && (
        <LinkWithArrow external={externalUrl} to={ctaUrl}>
          {ctaText}
        </LinkWithArrow>
      )}
    </section>
  )
}

export default FeatureStrip
